import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntelliDatepickerComponent } from './intelli-datepicker/intelli-datepicker.component';
import { TextMaskModule } from 'angular2-text-mask';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormField } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { IntelliYesornoComponent } from './intelli-yesorno/intelli-yesorno.component';
import { IntelliDataSelectorComponent } from './intelli-data-selector/intelli-data-selector.component';
import { IntelliSelectorComponent } from './intelli-selector/intelli-selector.component';
import { IntelliDecimalComponent } from './intelli-decimal/intelli-decimal.component';
import { IntelliEditMenuComponent } from './intelli-edit-menu/intelli-edit-menu.component';
import { IntelliTextEditorComponent } from './intelli-text-editor/intelli-text-editor.component';
import { DialogsModule } from '../dialogs/dialogs.module';
import { IntelliDataSelectorService } from './intelli-data-selector/intelli-data-selector.service';
import { IntelliTextAreaEditorComponent } from './intelli-textarea-editor/intelli-textarea-editor.component';
import { CardModule } from 'ngx-card';
import { IntelliCreditCarcEditorComponent } from './intelli-credit-card-editor/intelli-credit-card-editor.component';


@NgModule({
    imports: [
        CommonModule,
        TextMaskModule,
        MatInputModule,
        FormsModule,
        HttpClientModule,
        MatNativeDateModule,
        ReactiveFormsModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatToolbarModule,
        MatIconModule,
        MatMenuModule,
        MatCardModule,
        MatSelectModule,
        MatDatepickerModule,
        MatNativeDateModule,
        FormsModule,
        ReactiveFormsModule,
        MatDialogModule,
        DialogsModule,
        CardModule
    ],
    exports: [IntelliDatepickerComponent,
        IntelliYesornoComponent,
        IntelliDataSelectorComponent,
        IntelliSelectorComponent,
        IntelliDecimalComponent,
        IntelliEditMenuComponent,
        IntelliTextEditorComponent,
        IntelliTextAreaEditorComponent,
        IntelliCreditCarcEditorComponent
    ],
    declarations: [
        IntelliDatepickerComponent,
        IntelliYesornoComponent,
        IntelliDataSelectorComponent,
        IntelliSelectorComponent,
        IntelliDecimalComponent,
        IntelliEditMenuComponent,
        IntelliTextEditorComponent,
        IntelliTextAreaEditorComponent,
        IntelliCreditCarcEditorComponent
    ],
    providers: [IntelliDataSelectorService]
})
export class IntelliControlsModule { }
